/**
 * Server-side function to fetch media settings
 */

import { cache } from 'react'
import { API_SERVER_BASE_URL } from './config'
import { fetchWithConnectionRetry } from './fetch-with-connection-retry'

const DEFAULT_MEDIA_SETTINGS = {
  activeProvider: 's3' as const,
  providers: {
    s3: {
      bucket: '',
      region: 'us-east-1',
      accessKeyId: '',
      secretAccessKey: '',
      publicBaseUrl: '',
      usePresignedUploads: true,
    },
  },
  keepLocalOriginals: false,
  presets: [],
};

export const getMediaSettingsServer = cache(async function getMediaSettingsServer() {
  try {
    // Admin CDN/preset değişiklikleri hızlı yansısın
    const response = await fetchWithConnectionRetry(`${API_SERVER_BASE_URL}/api/media/settings`, {
      next: { revalidate: 30, tags: ['media-settings'] },
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      return DEFAULT_MEDIA_SETTINGS;
    }
    const ct = response.headers.get('content-type') || ''
    if (!ct.includes('application/json')) {
      return DEFAULT_MEDIA_SETTINGS
    }
    // await şart: aksi halde HTML body JSON parse hatası try/catch dışına kaçar
    return await response.json();
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Failed to fetch media settings on server:', error);
    }
    return DEFAULT_MEDIA_SETTINGS;
  }
})
